import { createFileRoute } from '@tanstack/react-router'

import ResetPasswordPage from '@/components/pages/auth/sign-in/containers/ResetPasswordPage'

export const Route = createFileRoute('/auth/reset-password')({
  component: ResetPasswordPage
})
